import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
import { customers_exports } from "./customers/index.js";
import { users_exports } from "./users/index.js";
//#region src/central/v2/index.ts
var v2_exports = /* @__PURE__ */ __exportAll({
	Customers: () => customers_exports,
	Users: () => users_exports
});
//#endregion
export { v2_exports };

//# sourceMappingURL=index.js.map